import { AlertTriangle, RotateCcw } from "lucide-react";
import type { Season } from "../types";
import { StaticNatureStage } from "../scene/StaticNatureStage";
import type { NatureStageSnapshot } from "../scene/stageState";

// 非实验页面使用轻量二维纸景，减少首屏 Three.js 下载与移动端耗电。
export function StaticBackdrop({
  season,
  snapshot,
  notice,
  onRetry
}: {
  season: Season;
  snapshot?: NatureStageSnapshot;
  notice?: string;
  onRetry?: () => void;
}) {
  return (
    <>
      <div className="nature-stage" aria-hidden="true" data-renderer="2d">
        <StaticNatureStage season={season} snapshot={snapshot} />
      </div>
      {notice && (
        <div className="stage-fallback-notice" role="status">
          <AlertTriangle size={18} aria-hidden="true" />
          <span><strong>已切换到二维观察模式</strong>{notice}</span>
          {onRetry && <button type="button" onClick={onRetry}><RotateCcw size={15} />重试 3D</button>}
        </div>
      )}
    </>
  );
}
